import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { CLIENT_ALLOWANCE_ITEM_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, createAllowanceItem } from 'src/reducers/clients/allowanceItems';
import { getItem, setItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { arrayToCheckBoxObject } from 'src/utils/Utils';
import { CLIENT_SETTINGS, CLIENT_ALLOWANCE_ITEMS } from 'src/constants/EndpointUrls';
import { useTranslation } from 'react-i18next';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import AllowanceItemEditingForm from './components/AllowanceItemEditingForm';

let NewAllowanceItemForm = reduxForm({
  form: CLIENT_ALLOWANCE_ITEM_FORM
})(AllowanceItemEditingForm);

const mapStateToProps = (state, ownProps) => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    payrollRulesGroups: ownProps.formatedPayrollGroup
  }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(createAllowanceItem(data));
  }
});

NewAllowanceItemForm = connect(mapStateToProps, mapDispatchToProps)(NewAllowanceItemForm);

const NewClientAllowanceItem = ({ dispatch, values }) => {
  const { clientAllowanceItem, checkedOnPayrollRulesGroups } = values;
  dispatch(setItem(REDUCER_NAME, clientAllowanceItem));

  const formatedPayrollGroup = arrayToCheckBoxObject(checkedOnPayrollRulesGroups);
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.ClientAllowanceItems.NewClientAllowanceItem.attendance_item_setting_additional_reegistration')}</h1>
      </div>
      <div className="l-wrap-xs">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.ClientAllowanceItems.NewClientAllowanceItem.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.ClientAllowanceItems.NewClientAllowanceItem.attendance_item_setting_list')} path={CLIENT_ALLOWANCE_ITEMS} />
            <BreadCrumb.Item label={t('features.ClientAllowanceItems.NewClientAllowanceItem.attendance_item_setting_additional_reegistration')} />
          </BreadCrumb>
        </div>
        <NewAllowanceItemForm formatedPayrollGroup={formatedPayrollGroup} />
      </div>
    </div>
  );
};

export default connect()(NewClientAllowanceItem);
